export const createTranslation = (locale: string) =>
  // eslint-disable-next-line global-require, import/no-dynamic-require
  require(`@shared/localisation/src/translations/b2c/${locale}/app-orders-common.json`);
